"use client";

import React, { useState } from 'react';
import SimpleOfferModal from './SimpleOfferModal';
import { Offer, ProductData } from '@/services/dataTypes';
import { getFinalDiscountTag } from '@/constants/hooks';
import Link from 'next/link';

interface Props {
    offer:             Offer | ProductData;
    merchantHref:      string;
    imageSrc:          string;
    merchantImg?:      string | null;
    domain:            string;
    type:              'anchor' | 'button';
    buttonClass?:      string;
    isDetail?:         number;        // if 1 → redirect to product detail page
    productDetailUrl?: string | null; // product detail page URL
}

const OfferDetailsToggle = ({
    offer, merchantImg, merchantHref, domain, type,
    buttonClass, imageSrc, isDetail, productDetailUrl,
}: Props) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const originalPrice   = offer?.original_price ? parseFloat(offer.original_price) : 0;
    const salePrice       = offer?.sale_price      ? parseFloat(offer.sale_price)     : 0;
    const discountPercent = originalPrice > 0 && salePrice > 0
        ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
        : null;

    const finalDiscountTag = getFinalDiscountTag(
        offer?.offer_title || offer?.offer_detail,
        discountPercent,
    );

    const label = 'View Details';
    const sharedClass = `${type === 'anchor' ? 'offer-details-anchor' : 'offer-details-btn'} cursor-pointer ${buttonClass || ''}`;

    /* ── is_detail === 1 + productDetailUrl → direct link ── */
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link
                href={productDetailUrl}
                className={`${buttonClass || ''}`}
            >
                {label}
            </Link>
        );
    }

    /* ── Otherwise → SimpleOfferModal ── */
    return (
        <>
            {type === 'anchor' ? (
                <span onClick={handleClick} className={sharedClass}>
                    {label}
                </span>
            ) : (
                <button
                    onClick={handleClick}
                    className={`px-4 py-2 rounded-xl bg-slate-100 hover:bg-slate-200
                                text-slate-900 font-bold text-sm transition-all
                                active:scale-95 ${buttonClass || ''}`}
                >
                    {label}
                </button>
            )}

            {showModal && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setShowModal(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                    merchantImg={merchantImg}
                    productImg={imageSrc}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
